import { create } from 'zustand';

const useGameStore = create((set, get) => ({
  isGameLoaded: false,
  setGameLoaded: (isGameLoaded) => set(() => ({ isGameLoaded })),
  installGuideOpen: false,
  setInstallGuideOpen: (installGuideOpen) => set(() => ({ installGuideOpen })),
}));

export default useGameStore;
